import { IonButton, IonButtons, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonListHeader, IonLoading, IonPage, IonRow, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { arrowBack, clipboardOutline, informationCircleOutline, locationOutline, navigateOutline, personOutline, phonePortraitOutline } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { urlBase } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import "./OrdensDetalhes.css";
import maps from './imgs/maps.png';
import waze from './imgs/waze.png';


type Props = {
  projetoid: string;
  configs: Object;
  abrirInserirAgendamento: boolean;
  onDismiss: () => void;
};

const OrdensDetalhes: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const location = useLocation<any>();
  const [dadosProjeto, setDadosProjeto] = useState<any>([]);
  const [operacaoCarregada, setOperacaoCarregada] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
  });

  let params: any = {
    projetoid: "",
    abrirInserirAgendamento: false,
    configs: "",
  }
  params = useParams();

  if (location && location.state && location.state.projetoid) {
    params.projetoid = location.state.projetoid;
    params.configs = location.state.configs;
    params.abrirInserirAgendamento = location.state.abrirInserirAgendamento;
  }


  if (props.projetoid) {
    params = {
      projetoid: props.projetoid,
      configs: props.configs,
      abrirInserirAgendamento: props.abrirInserirAgendamento
    }
  }

  function carregarProjeto() {
    if (params.projetoid != "" && params.projetoid != undefined) {
      if (!operacaoCarregada) {
        setOperacaoCarregada(true);

        var token: string = "";
        var tkn = localStorage.getItem("token");
        if (typeof (tkn) === "string") { token = tkn; }
        console.log("projetoid", params.projetoid);
        const getoperacao = async () => {

          setShowLoading(true);
          const resp = await fetch(urlBase.url + "/mobile/ordens/" + params.projetoid.replaceAll(/#/g, '%23'),
            {
              method: urlBase.method,
              headers: [
                ["token", token],
                ["perfil", window.localStorage.getItem("perfil") || ""],
                ["marca", window.localStorage.getItem("marca") || ""],
              ],
              credentials: 'include'
            });
          const operacao = await resp.json();
          //if (resp.status === 400 || resp.status === 401) history.replace("/primeiroacesso/");
          if (operacao.Item !== undefined) {

            setDadosProjeto(operacao.Item);

            console.log("dadosprojeto", operacao.Item);

            console.log("abrirInserirAgendamento", params.abrirInserirAgendamento);

            if (params.abrirInserirAgendamento === true) {
            }


            setShowLoading(false);
          }

        }

        getoperacao();
      }
    }
    return "";
  }

  function formataTelefone(numero: any) {
    if (numero?.length == 13) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else if (numero?.length == 12) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else { return "" };
  }


  const loadResponsaveis = () => {

    return dadosProjeto.responsaveis?.map((value: any) => (

      <IonItem lines="none" key={"semOperacao"}>

        <IonLabel className="ion-text-wrap">
          <h3 style={{ "verticalAlign": "middle" }}>{value.nome}</h3>
        </IonLabel>
      </IonItem>

    ))
  }

  function preencheArquivos(value: any) {

    return (
      (value.arquivos) ?
        (<>
          {value.arquivos.map((arq: any, index: any) => (

            <IonCol size="6" key={index} >

              <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '0px', paddingBottom: '10px', position: 'relative' }}>
                <div style={{ maxWidth: '350px', width: '100%' }}>
                  <a target='_blank' href={arq.split(";")[1]}>
                    {arq.split(";")[0]}
                  </a>
                </div>
              </div>
            </IonCol>
          ))}

        </>) :
        (
          <>
            {/* {preencheCard(value, index)} */}
          </>
        )
    )
  }

  return (

    <IonPage className="OrdensDetalhes">
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <div>
            {carregarProjeto()}
          </div>
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack(); }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Detalhes</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen={false}>

        <IonList>
          <IonListHeader lines="full">
            <IonLabel>{dadosProjeto && dadosProjeto.servicoTipo ? dadosProjeto.servicoTipo : "Projeto"}</IonLabel>
          </IonListHeader>
          <IonItem lines="none">
            <IonIcon icon={clipboardOutline} slot="start" />
            <div className="contentList">
              <h1>Nome</h1>
              <h2>{dadosProjeto && dadosProjeto.nomeProjeto ? dadosProjeto.nomeProjeto : "não identificado"}</h2>
            </div>
          </IonItem>

          {/* <IonItem lines="none">
            <IonIcon icon={cubeOutline} slot="start" />
            <div className="contentList">
              <h1>Descrição</h1>
              <h2>{dadosProjeto && dadosProjeto.descricaoProjeto ? dadosProjeto.descricaoProjeto : "não identificado"}</h2>
            </div>
          </IonItem> */}
          <IonItem lines="none">
            <IonIcon icon={informationCircleOutline} slot="start" />
            <div className="contentList">
              <h1>Status</h1>
              <h2>{dadosProjeto ? dadosProjeto.statusWorkflow : ""}</h2>
            </div>
          </IonItem>

          <IonListHeader lines="full">
            <IonLabel>Responsáveis</IonLabel>
          </IonListHeader>

          {loadResponsaveis()}


          <IonListHeader lines="full">
            <IonLabel>Empresa</IonLabel>
          </IonListHeader>
          <IonItem lines="none">
            <IonIcon src={personOutline} slot="start" />
            <div className="contentList">
              <h1>Nome</h1>
              <h2>{dadosProjeto && dadosProjeto.empresaNome ? dadosProjeto.empresaNome : "não identificado"}</h2>
            </div>
          </IonItem>
          <IonItem lines="none">
            <IonIcon src={phonePortraitOutline} slot="start" />
            <div className="contentList">
              <h1>Telefone</h1>
              <div style={{ paddingTop: "10px", display: "flex", columnGap: "20px", justifyContent: "left" }} >
                <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (dadosProjeto ? dadosProjeto.empresaTelefone : "")}><h2>{dadosProjeto && dadosProjeto.empresaTelefone ? formataTelefone(dadosProjeto.empresaTelefone) : ""}</h2></a>
              </div>
            </div>
          </IonItem>

          <IonItem lines="none">
            <IonIcon src={locationOutline} slot="start" />
            <div className="contentList">
              <h1>Endereço</h1>
              <h2>{dadosProjeto && dadosProjeto.empresaEndereco ? dadosProjeto.empresaEndereco : "não identificado"}</h2>
            </div>
          </IonItem>

          <IonItem lines="none">
            <IonIcon src={navigateOutline} slot="start" />
            <div className="contentList">
              <div style={{ paddingTop: "10px", display: "flex", columnGap: "20px", justifyContent: "left" }} >
                <a target='_blank' href={"https://www.google.com/maps/search/?api=1&query=" + (dadosProjeto ? dadosProjeto.empresaLatitude + "," + dadosProjeto.empresaLongitude + "&query_place_id=" : "")}><img src={maps} alt="maps" /></a>
                <a target='_blank' href={"https://waze.com/ul?ll=" + (dadosProjeto ? dadosProjeto.empresaLatitude + "%2C" + dadosProjeto.empresaLongitude : "") + "&navigate=yes"}><img src={waze} alt="waze" /></a>
              </div>
            </div>
          </IonItem>

          <IonListHeader lines="full" hidden={window.localStorage.getItem("perfil") == "cliente" && localStorage.getItem("compartilhado") == "false"}>
            <IonLabel>Cliente</IonLabel>
          </IonListHeader>
          <IonItem lines="none" hidden={window.localStorage.getItem("perfil") == "cliente" && localStorage.getItem("compartilhado") == "false"}>
            <IonIcon src={personOutline} slot="start" />
            <div className="contentList">
              <h1>Nome</h1>
              <h2>{dadosProjeto && dadosProjeto.clienteNome ? dadosProjeto.clienteNome : "não identificado"}</h2>
            </div>
          </IonItem>

          <IonItem lines="none" hidden={window.localStorage.getItem("perfil") == "cliente" && localStorage.getItem("compartilhado") == "false"}>
            <IonIcon src={phonePortraitOutline} slot="start" />
            <div className="contentList">
              <h1>Telefone</h1>
              <div style={{ paddingTop: "10px", display: "flex", columnGap: "20px", justifyContent: "left" }} >
                <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (dadosProjeto ? dadosProjeto.clienteTelefone : "")}><h2>{dadosProjeto && dadosProjeto.clienteTelefone ? formataTelefone(dadosProjeto.clienteTelefone) : "não identificado"}</h2></a>
              </div>
            </div>
          </IonItem>


          {dadosProjeto.arquivos && Array.isArray(dadosProjeto.arquivos) && dadosProjeto.arquivos.length > 0 && (
            <>
              <IonListHeader lines="full">
                <IonLabel>Arquivos</IonLabel>
              </IonListHeader>
              <IonList lines="full" class="ion-no-margin">
                <IonGrid>
                  <IonRow>

                    {preencheArquivos(dadosProjeto)}
                  </IonRow>
                </IonGrid>
              </IonList>
            </>
          )}
        </IonList>






        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>
      <IonFooter className="ion-no-border" hidden={dadosProjeto.layoutSimplificado}>
        <IonToolbar>
          <IonButton size='large' expand="block" onClick={() => {
            console.log("dadosProjeto.pk", dadosProjeto.pk.replaceAll(/#/g, '%23'));
            window.localStorage.setItem("configWorkflowProjeto", JSON.stringify(dadosProjeto.configWorkflow));
            history.push("../ordens/ordensworkflow", { projetoid: dadosProjeto.pk.replaceAll(/#/g, '%23'), configs: JSON.stringify(dadosProjeto.configWorkflow), abrirInserirAgendamento: false });
          }}>{dadosProjeto.nomeLinhaDoTempo ? dadosProjeto.nomeLinhaDoTempo : "Linha do tempo"}</IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );


};

export default OrdensDetalhes;